import { EventEmitter, Injectable } from '@angular/core';
import { GlobalEvent } from '~core/models/shared.models';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private readonly _eventEmitter: EventEmitter<GlobalEvent> =
    new EventEmitter();

  readonly events$ = this._eventEmitter.asObservable();

  emit(event: GlobalEvent): void {
    this._eventEmitter.emit(event);
  }
}
